import {Toast} from 'bootstrap'
export enum popupType {
    PRIMARY = "primary",
    SUCCESS = "success",
    WARNING = "warning",
    DANGER = "danger"
}

interface popupOptions {
    title?: string;
    content: string;
    type?: popupType
}

class Alert {
    toastelement: HTMLBaseElement;

    constructor() {
        this.toastelement = document.getElementById("system-toast") as HTMLBaseElement;
        if (this.toastelement) {
            this.toastelement.addEventListener("hidden.bs.popover", () => {
                this.decoratePopup({ title: "", content: "" });
            });
        }
    }

    show = (options: popupOptions) => {
        this.decoratePopup(options);
        this.getToast().show();
    }

    private decoratePopup = (options: popupOptions) => {
        Object.values(popupType).forEach((value) => {
            this.toastelement.classList.remove("bg-" + value)
        });

        this.toastelement.classList.add("bg-" + (options.type ?? "success"));

        const contentEl = document.getElementById("system-toast-body") as HTMLBaseElement;
        contentEl.innerHTML = options.content;
    }

    private getToast = () => {
        return Toast.getOrCreateInstance(this.toastelement);
    }
}

export const alert = new Alert();